import { render } from "./BlockTable.vue?vue&type=template&id=d1459bb2"
import script from "./BlockTable.vue?vue&type=script&lang=js"
export * from "./BlockTable.vue?vue&type=script&lang=js"

import "./BlockTable.vue?vue&type=style&index=0&id=d1459bb2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__